import { render, staticRenderFns } from "./personXd.vue?vue&type=template&id=63730337&scoped=true&"
import script from "./personXd.vue?vue&type=script&lang=js&"
export * from "./personXd.vue?vue&type=script&lang=js&"
import style0 from "./personXd.vue?vue&type=style&index=0&id=63730337&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63730337",
  null
  
)

export default component.exports